import { Button, ChevronDownIcon, cn } from '@mr-yum/frontend-ui'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useSheetToggle } from '@/components/VenueV2/utils/sheetUtils'
import { getOrderingTypeName } from '@/components/VenueV2/utils/venueUtils'
import { useOrderingTypeContext } from '@/contexts/VenueOrderContext'
import { VenueLandingQuery } from '@/gql/graphql'
import { useLoggerLegacy } from '@/hooks/useLogger'

interface Props {
  venue: VenueLandingQuery['guestVenue']
  hasMultipleOrderingTypes: boolean
}

export const OrderingTypeButton = ({
  venue,
  hasMultipleOrderingTypes,
}: Props) => {
  const { logEventLegacy } = useLoggerLegacy()
  const sheetToggle = useSheetToggle()
  const intl = useIntl()

  const handleOnClick = useCallback(() => {
    logEventLegacy('Clicked on order type selector')
    void sheetToggle({
      sheet: 'ordering-type',
    })
  }, [logEventLegacy, sheetToggle])

  const { orderingType } = useOrderingTypeContext()
  const name = getOrderingTypeName(venue, orderingType, intl)

  if (!hasMultipleOrderingTypes) {
    return (
      <label
        className={cn(
          'mr-1 min-h-5 cursor-not-allowed items-center gap-0 text-action-text-primary-foreground my-label-sm',
        )}
      >
        {name}
      </label>
    )
  }

  return (
    <Button
      type="button"
      variant="link-primary"
      size="sm"
      onClick={handleOnClick}
      className="min-h-5 items-center gap-0"
      aria-label={intl.formatMessage({
        defaultMessage: 'Change ordering type',
        id: 'nCRaPf',
      })}
      data-testid="change-ordering-type"
      rightIcon={
        <ChevronDownIcon width={20} height={20} className="flex-shrink-0" />
      }
    >
      {name}
    </Button>
  )
}
